import * as React from "react";
import PropTypes from "prop-types";
import Backbone from "backbone";
import prefixStyles from "nx-components/utils/prefixStyles";
import Tappable, { simpleActiveBackgroundColor } from "nx-components/Tappable";
import Slider from "nx-components/Slider";
import {
  IconPause,
  IconPlay,
  IconVolumeHigh,
  IconVolumeMedium,
  IconVolumeLow,
  IconVolumeMute,
} from "nx-components/Icons";
import Dispatch from "nexia_mobile/flux_like/dispatch";

const sliderStyle = prefixStyles({ flex: "1 0 auto", margin: "1em 0.5em" });

export default class SpeakerTileControls extends React.Component {
  static propTypes = {
    model: PropTypes.instanceOf(Backbone.Model).isRequired,
  };

  state = {
    showVolumeSlider: false,
  };

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getVolumeIcon(volume) {
    if (volume > 75) {
      return IconVolumeHigh;
    }
    if (volume > 30) {
      return IconVolumeMedium;
    }
    if (volume > 0) {
      return IconVolumeLow;
    }
    return IconVolumeMute;
  }

  momentarilyShowVolumeSlider() {
    this.setState({ showVolumeSlider: true });
    this.hideVolumeSliderEventually();
  }

  hideVolumeSliderEventually = _.debounce(() => {
    if (!this._isMounted) {
      return;
    }
    // if no volume changes have been made for 5 seconds, hide the volume slider.
    this.setState({ showVolumeSlider: false });
  }, 5000);

  onVolumeChanged(value) {
    this.momentarilyShowVolumeSlider(); // wait 5 seconds after every change.
    if (value !== this.props.model.get("volume")) {
      this.props.model.setVolume(value);
    }
  }

  onPlay() {
    if (this.props.model.get("is_playing")) {
      this.props.model.pause();
    } else {
      this.props.model.play();
    }
  }

  render() {
    let isPlaying = this.props.model.get("is_playing");
    let volume = this.props.model.get("volume");
    let VolumeIcon = this.getVolumeIcon(volume);
    let volumeControl;

    if (this.state.showVolumeSlider) {
      volumeControl = (
        <Slider
          min="0"
          max="100"
          value={volume}
          onChange={(value) => this.onVolumeChanged(value)}
          onDragStart={() => Dispatch("DISABLE_LOCATION_POLLING")}
          onDragEnd={() => Dispatch("ENABLE_LOCATION_POLLING")}
          formatValue={(value) => `Volume ${value}%`}
          style={sliderStyle}
        />
      );
    } else {
      volumeControl = (
        <Tappable onTap={() => this.momentarilyShowVolumeSlider()}>
          {({ tapTargetRefHandler }) => (
            <div
              className="device-control-disclosure"
              ref={tapTargetRefHandler}
              tabIndex="0"
            >
              <VolumeIcon className="device-control-disclosure-action" />
            </div>
          )}
        </Tappable>
      );
    }

    return (
      <div>
        <Tappable onTap={() => this.onPlay()}>
          {({ tapTargetRefHandler, active }) => (
            <div
              className="device-control-disclosure"
              ref={tapTargetRefHandler}
              tabIndex="0"
              style={{ backgroundColor: simpleActiveBackgroundColor(active) }}
            >
              {isPlaying ? (
                <IconPause className="device-control-disclosure-action" />
              ) : (
                <IconPlay className="device-control-disclosure-action" />
              )}
            </div>
          )}
        </Tappable>
        {volumeControl}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Controls/Speaker/SpeakerTileControls.jsx